import { IconButton as MuiIconButton, IconButtonProps } from '@mui/material';
import withClickTracking from './withClickTracking';

const IconButton = withClickTracking<IconButtonProps>(MuiIconButton);

export default IconButton;
